// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import Close from "@steiner/XDL/Icons/Close";
import NavArrowDown from "@steiner/XDL/Icons/NavArrowDown";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xBaseTheme } from "@steiner/XDL/types";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: NavArrowDown,
            size: 10,
            css: css`
                color: ${color("primary")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
        cssOverrides: {
            selectedText: css`
                font-size: 14px;
                padding: ${({ _sizeVariant }: any) =>
                    _sizeVariant === "small" ? "1px 24px 1px 11px" : "6px 24px 6px 11px"};
            `,
            dropdownWrapper: css`
                & input ~ ${IconWrapper} {
                    padding: 10px;
                }
                & input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
                & input:disabled ~ ${IconWrapper} {
                    color: ${color("common.ui8", 0.33)};
                    background: transparent;
                }
            `,
            stickyHeaderOption: css`
                position: sticky;
                top: 0;
                width: 100%;
                padding: 8px;
                font-size: 14px;
                margin-bottom: 0;
                line-height: 19px;
                font-weight: ${fontConfig.weight.bold};
                color: ${color("text")};
                background: ${color("common.ui1")};
                border-bottom: 1px solid ${color("common.border")};
            `,
        },
        css: css``,
        clearClickableStyles: {
            clickableProps: {
                css: css`
                    &&& {
                        right: 35px;
                    }

                    &:disabled {
                        display: none;
                    }

                    & > ${IconWrapper} {
                        transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;
                        color: ${color("primary")};
                    }

                    &:hover > ${IconWrapper} {
                        color: ${color("common.ui9")};
                    }
                `,
            },
            iconProps: {
                size: 16,
                src: Close,
            },
        },
    },
} as xBaseTheme["dynamicDropdown"];
